const cartDe = {
	title: 'Meine Einkaufstasche',
	clearAll: 'Alles löschen',
	itemsInBag: (n) => `${n} Artikel in Ihrer Tasche`,
	sectionCartItems: 'Artikel in Ihrer Tasche',
	continueShopping: 'Weiter einkaufen',
	orderSummary: 'Bestellübersicht',
	subtotal: 'Zwischensumme',
	delivery: 'Liefergebühr',
	free: 'Gratis',
	discount: 'Rabatt',
	total: 'Gesamt',
	couponPlaceholder: 'Gutscheincode eingeben',
	applyCoupon: 'Gutschein anwenden',
	proceedCheckout: 'Zur Kasse gehen',
	trust: {
		securePayment: '100% sichere Zahlung',
		fastDelivery: 'Schnelle Lieferung',
		cod: 'Barzahlung bei Lieferung'
	},
	empty: {
		title: 'Ihr Warenkorb ist leer',
		subtitle: 'Es sieht so aus, als hätten Sie noch keine Artikel hinzugefügt.\nStöbern Sie in unseren schönen Produkten und beginnen Sie mit dem Einkauf!',
		cta: 'Jetzt einkaufen'
	},
	item: {
		inStock: 'Auf Lager',
		removed: 'Artikel aus dem Warenkorb entfernt'
	},
	cleared: 'Alle Artikel aus dem Warenkorb entfernt'
};

export default cartDe;


